<!--
  - Copyright (c) 2022. Venus GmbH <info@venus.bayern> - All Rights Reserved
  - Unauthorized copying of this file, via any medium is strictly prohibited Proprietary and confidential
  - Written by Dominik Lippl <dl@venus.bayern>
  -->

<template>
    <div class="scopes">
        <loading-component>
            <template #content>
                <div class="flex flex-col gap-4">
                    <div class="self-end">
                        <button-component
                            fa-icon="fa-regular fa-plus"
                            background-color="bg-green-600"
                            @click="$router.push(`/scopes/create`)"
                        >
                        </button-component>
                    </div>

                    <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                        <card-component v-for="(scope, index) of scopesStore.scopes" v-bind:key="index">
                            <template v-slot:body>
                                <div class="flex flex-row gap-4 items-center break-all">
                                    <div class="flex flex-col">
                                        <h2 class="card-title">{{ scope.name }}</h2>

                                        <div class="flex flex-col text-gray-400 text-sm">
                                            <div>Identifier: {{ scope.identifier }}</div>
                                            <div>Beschreibung: {{ scope.description }}</div>
                                            <div>Claims: {{ (scope.claims ?? []).join(', ') }}</div>
                                        </div>
                                    </div>
                                </div>
                            </template>

                            <template v-slot:footer>
                                <button-component
                                    fa-icon="fa-regular fa-pencil"
                                    @click="$router.push(`/scopes/${scope.identifier}`)"
                                />
                                <delete-component @delete="deleteScope(scope.identifier)" />
                            </template>
                        </card-component>
                    </div>
                </div>
            </template>
        </loading-component>
    </div>
</template>

<script>
import { mapStores } from 'pinia';
import { useScopesStore } from '@/stores/scopes';
import CardComponent from '@/components/CardComponent';
import LoadingComponent from '@/components/LoadingComponent';
import ButtonComponent from '@/components/ButtonComponent';
import DeleteComponent from '@/components/DeleteComponent';
import Notifications from '@auth/vue-share/utility/notifications';
import logger from '@auth/vue-share/utility/logger';

export default {
    name: 'ScopesView',
    components: { DeleteComponent, ButtonComponent, LoadingComponent, CardComponent },
    created() {
        this.scopesStore.fetchScopes();
    },
    computed: {
        ...mapStores(useScopesStore)
    },
    methods: {
        deleteScope(scope_identifier) {
            this.scopesStore
                .deleteScope(scope_identifier)
                .then(() => {
                    Notifications.success('Scope erfolgreich gelöscht');
                })
                .catch((error) => {
                    Notifications.error('Scope konnte nicht gelöscht werden');
                    logger.error('[SCOPES]', error);
                });
        }
    }
};
</script>

<style scoped></style>
